import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { ScrollArea } from "@/components/ui/scroll-area";
import type { DisparoLead, DisparoMessagePayload } from "@/lib/disparos-types";
import { formatPhoneForDisplay } from "@/lib/format-phone";

interface DisparoAdvancedFormProps {
  campaignName: string;
  onCampaignNameChange: (v: string) => void;
  leads: DisparoLead[];
  messagesByLeadId: Record<string, DisparoMessagePayload>;
  onMessageChange: (leadId: string, message: DisparoMessagePayload) => void;
  defaultText: string;
  onDefaultTextChange: (v: string) => void;
  delayMin: number;
  delayMax: number;
  onDelayMinChange: (v: number) => void;
  onDelayMaxChange: (v: number) => void;
  scheduledAt: string;
  onScheduledAtChange: (v: string) => void;
}

export function DisparoAdvancedForm({
  campaignName,
  onCampaignNameChange,
  leads,
  messagesByLeadId,
  onMessageChange,
  defaultText,
  onDefaultTextChange,
  delayMin,
  delayMax,
  onDelayMinChange,
  onDelayMaxChange,
  scheduledAt,
  onScheduledAtChange,
}: DisparoAdvancedFormProps) {
  return (
    <div className="space-y-4">
      <div className="space-y-1.5">
        <Label htmlFor="adv-disparo-name">Nome da campanha</Label>
        <Input
          id="adv-disparo-name"
          placeholder="Ex: Follow-up personalizado"
          value={campaignName}
          onChange={(e) => onCampaignNameChange(e.target.value)}
        />
      </div>

      <div className="space-y-1.5">
        <Label htmlFor="default-text">Texto padrão (aplicado a novos)</Label>
        <Textarea
          id="default-text"
          rows={2}
          placeholder="Mensagem base — personalize por lead abaixo"
          value={defaultText}
          onChange={(e) => onDefaultTextChange(e.target.value)}
        />
      </div>

      <div className="grid grid-cols-2 gap-4">
        <div className="space-y-1.5">
          <Label>Delay mínimo (s)</Label>
          <Input
            type="number"
            min={0}
            value={delayMin}
            onChange={(e) => onDelayMinChange(Number(e.target.value) || 0)}
          />
        </div>
        <div className="space-y-1.5">
          <Label>Delay máximo (s)</Label>
          <Input
            type="number"
            min={0}
            value={delayMax}
            onChange={(e) => onDelayMaxChange(Number(e.target.value) || 0)}
          />
        </div>
      </div>

      <div className="space-y-1.5">
        <Label>Agendar para (opcional)</Label>
        <Input
          type="datetime-local"
          value={scheduledAt}
          onChange={(e) => onScheduledAtChange(e.target.value)}
        />
      </div>

      <div className="space-y-2">
        <Label>Mensagem por destinatário ({leads.length})</Label>
        <ScrollArea className="h-[280px] rounded-md border">
          <div className="divide-y p-2 space-y-2">
            {leads.map((lead) => (
              <div key={lead.id} className="space-y-1 pb-2">
                <p className="text-sm font-medium">
                  {lead.name || lead.phone}{" "}
                  <span className="text-muted-foreground font-normal text-xs">
                    {formatPhoneForDisplay(lead.phone)}
                  </span>
                </p>
                <Textarea
                  rows={2}
                  placeholder={defaultText || "Mensagem..."}
                  value={messagesByLeadId[lead.id]?.text || ""}
                  onChange={(e) =>
                    onMessageChange(lead.id, {
                      type: "text",
                      text: e.target.value,
                    })
                  }
                />
              </div>
            ))}
          </div>
        </ScrollArea>
      </div>
    </div>
  );
}
